import { render, staticRenderFns } from "./dataCleaningSearchcompany.vue?vue&type=template&id=0be71373&scoped=true&"
import script from "./dataCleaningSearchcompany.vue?vue&type=script&lang=js&"
export * from "./dataCleaningSearchcompany.vue?vue&type=script&lang=js&"
import style0 from "./dataCleaningSearchcompany.vue?vue&type=style&index=0&id=0be71373&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be71373",
  null
  
)

export default component.exports